import React from "react";
import { Divider, Flex, Heading, Link, Text, VStack } from "@chakra-ui/react";
import Card from "../../layout/card";
import ReivList from "../../common/reivList";
import Stripe from "stripe";

const SuccessPage: React.FC<{ invoice: Stripe.Invoice | undefined }> = ({
  invoice,
}) => {
  return (
    <Card maxW="800px">
      <VStack
        textAlign="center"
        margin="auto"
        spacing="0.5rem"
        alignItems="center"
        maxWidth="600px"
      >
        <Heading size="lg">
          Congratulations - your payment was successful!
        </Heading>
        <Text fontSize="md">
          Your invoice number is{" "}
          <Link href={invoice?.invoice_pdf ?? "#"}>{invoice?.number}</Link>.
        </Text>
        <Text fontSize="md">
          We've sent a copy of the invoice and receipt to the email address you
          provided.
        </Text>

        <Divider style={{ marginTop: "1.5rem", marginBottom: "1rem" }} />

        <Heading alignSelf="center" size="md">
          You're nearly an REIV Member
        </Heading>
        <Text alignSelf="center">Here's what will happen next:</Text>
        <Flex alignSelf="center" textAlign="left" maxWidth="400px">
          <ReivList
            data={[
              {
                description: `The REIV will review your application to ensure you meet the membership criteria and confirm you work in the industry.`,
              },
              {
                description: `Once you’ve been reviewed, you’ll be sent a welcome email from the REIV membership team (normally in a business day or two — call 03 9205 6666 for urgent enquiries.`,
              },
              {
                description: (
                  <Text d="inline">
                    After that, you’ll receive a log-in to the{" "}
                    <Link href="https://members.reiv.com.au" target="_blank">
                      members.reiv.com.au
                    </Link>{" "}
                    portal where you can start taking advantage of all of our
                    members-only insights, resources and benefits.
                  </Text>
                ),
              },
            ]}
          />
        </Flex>
        <Divider style={{ marginTop: "1.5rem", marginBottom: "1rem" }} />
        <Text>
          We look forward to having you as part of our growing community of
          budding real estate agents and experienced professionals.
        </Text>
        <Text>The REIV Memberships Team</Text>
        <Text fontSize="sm" padding="0 4px 0 4px" mt="2rem !important">
          If you don’t qualify as an individual member (that is, you aren’t a
          Licensed Estate Agent, Agent’s Representative, Owners Corporation
          Manager or Valuer) we’ll let you know and you can either cancel your
          application and we’ll refund your application fee minus a small
          processing fee. Otherwise we can help you{" "}
          <Link href="https://reiv.com.au/membership/affiliate-of-the-institute">
            apply as an Affiliate Member.
          </Link>
        </Text>
        <Text fontSize="sm" padding="0 4px 0 4px" mt="2rem !important">
          Please note, this is an application only. Your Membership will only be
          confirmed after your application has been reviewed and referred to the
          Board appointed Membership Committee for approval. The Membership team
          will contact you as soon as your application is approved.
        </Text>
      </VStack>
    </Card>
  );
};

export default SuccessPage;
